import React, { lazy, Suspense, useRef } from "react";
import { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";

import StarryNightSky from "./Stars";

import benifits from "../utils/data/BLOCKBENIFITS.json";
import features_coaler from "../utils/data/FEATURES.json";

function BlockchainDiagram() {
  const [viewAll, setViewAll] = useState(false);
  const [viewAllBlock, setViewAllBlock] = useState(false);
  const containerRef = useRef(null);
  const handleViewAll = () => {
    setViewAll(true);
  };

  return (
    <>
      <div className="relative py-[90px] bg-black text-white flex justify-center">
        <StarryNightSky height="150vh" />
        <div className="max-w-[1380px] w-full flex flex-col items-center gap-14">
          <div className="font-black text-4xl leading-10 text-center">
            Key{" "}
            <span
              className="bg-clip-text text-transparent"
              style={{
                backgroundImage:
                  "linear-gradient(90deg, #AB93FA 0%, #4410EE 100%)",
              }}
            >
              features
            </span>
          </div>

          <div className="hidden md:flex justify-center gap-12 flex-wrap">
            {features_coaler.FEATURES.map((f, index) => (
              <div
                key={index}
                className="w-[420px] border-[3px] border-[#1B0073] rounded-3xl gap-6 py-6 px-8 bg-white/10 shadow-lg"
                style={{
                  boxShadow: "4px 4px 250px 10px rgba(27, 0, 115, 0.25)",
                }}
              >
                <div className="flex gap-3 items-center">
                  <h1 className="font-bold text-[24px] leading-[100%]">
                    {f.title}
                  </h1>
                  <img src={`blockchain-icon-${index + 1}.png`} alt="" />
                </div>
                <div>
                  <p className="font-medium text-[20px] leading-[160%] tracking-normal">
                    {f.description}
                  </p>
                </div>
              </div>
            ))}
          </div>

          <div className="relative w-full md:hidden px-4">
            {!viewAll ? (
              <>
                <Swiper
                  key="swiper"
                  modules={[Autoplay]}
                  spaceBetween={20}
                  slidesPerView="auto"
                  loop={true}
                  autoplay={{ delay: 2000, disableOnInteraction: false }}
                  centeredSlides={true}
                  initialSlide={2}
                >
                  {features_coaler.FEATURES.map((f, index) => (
                    <SwiperSlide
                      key={index}
                      style={{ width: "270px", height: "160px" }}
                      className="!flex !items-start !justify-start"
                    >
                      <div
                        className="max-w-[270px] min-h-[160px] border-[3px] border-[#1B0073] rounded-3xl py-4 px-4 bg-white/10 shadow-lg flex flex-col"
                        style={{
                          boxShadow:
                            "4px 4px 250px 10px rgba(27, 0, 115, 0.25)",
                        }}
                      >
                        <div className="flex items-center gap-2 mb-2">
                          <img
                            src={`blockchain-icon-${index + 1}.png`}
                            alt=""
                            className="w-6 h-6"
                          />
                          <h1 className="font-bold text-[16px] leading-[100%]">
                            {f.title}
                          </h1>
                        </div>
                        <p className="font-medium text-[14px] leading-[150%]">
                          {f.description}
                        </p>
                      </div>
                    </SwiperSlide>
                  ))}
                </Swiper>

                <div className="flex justify-center mt-6">
                  <button
                    onClick={handleViewAll}
                    className="flex items-center  gap-2 px-4 py-2 border border-white text-white rounded-full text-sm font-semibold hover:bg-white hover:text-black transition-all duration-300 "
                  >
                    View All
                    <img
                      src="/down_symbol.png"
                      alt="Down Arrow"
                      className="w-4 h-4"
                    />
                  </button>
                </div>
              </>
            ) : (
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-4 justify-items-center">
                {features_coaler.FEATURES.map((f, index) => (
                  <div
                    key={index}
                    className="w-[270px] h-[160px] border-[3px] border-[#1B0073] rounded-3xl py-4 px-4 bg-white/10 shadow-lg flex flex-col"
                    style={{
                      boxShadow: "4px 4px 250px 10px rgba(27, 0, 115, 0.25)",
                    }}
                  >
                    <div className="flex items-center gap-2 mb-2">
                      <img
                        src={`blockchain-icon-${index + 1}.png`}
                        alt=""
                        className="w-6 h-6"
                      />
                      <h1 className="font-bold text-[16px] leading-[100%]">
                        {f.title}
                      </h1>
                    </div>
                    <p className="font-medium text-[14px] leading-[150%]">
                      {f.description}
                    </p>
                  </div>
                ))}
              </div>
            )}
          </div>

          <div className="hidden lg:flex relative flex-col justify-center items-center min-h-[800px]">
            <div className="w-[420px] h-[280px] relative  rounded-[24px] bg-[#FFFFFF1A] [clip-path:polygon(50%_0%,100%_25%,100%_75%,50%_100%,0%_75%,0%_25%)] flex items-center justify-center p-6 text-white text-center">
              <div className="w-full h-full rounded-[24px]  bg-transparent [clip-path:polygon(50%_0%,100%_25%,100%_75%,50%_100%,0%_75%,0%_25%)] flex flex-col items-center justify-center px-4">
                <h3 className="text-xl font-semibold mb-2">
                  Powered by
                  <br />
                  <span className="bg-[linear-gradient(90deg,_#3C00FF_0%,_#C800FF_51.5%)] bg-clip-text text-transparent">
                    Blockchain
                  </span>{" "}
                  Technology
                </h3>
                <p className="text-sm mb-2">
                  “Transparency, Security, and Efficiency at Every Step"
                </p>
                <p className="text-sm font-medium">
                  Coaler leverages blockchain technology to revolutionize the
                  coal supply chain.
                </p>
              </div>
            </div>
            {benifits.BLOCKCHAINBENEFITS.map((item, i) => (
              <div
                key={i}
                className="absolute flex flex-col items-center w-[314px]"
                style={{
                  ...(i === 0 && { top: "68px" }),
                  ...(i === 1 && { top: "200px", left: "-347px" }),
                  ...(i === 2 && { top: "200px", right: "-347px" }),
                  ...(i === 3 && { top: "560px", left: "-130px" }),
                  ...(i === 4 && { top: "560px", right: "-130px" }),
                }}
              >
                <div
                  className="absolute w-0.5"
                  style={{
                    backgroundImage:
                      "linear-gradient(90deg, #AB93FA 0%, #4410EE 100%)",
                    ...(i === 0 && {
                      top: "164px",
                      height: "32px",
                    }),
                    ...(i === 1 && {
                      top: "108px",
                      left: "332px",
                      height: "36px",
                      transform: "rotate(110deg)",
                    }),
                    ...(i === 2 && {
                      top: "108px",
                      right: "332px",
                      height: "36px",
                      transform: "rotate(70deg)",
                    }),
                    ...(i === 3 && {
                      top: "-52px",
                      left: "240px",
                      height: "56px",
                      transform: "rotate(30deg)",
                    }),
                    ...(i === 4 && {
                      top: "-52px",
                      right: "240px",
                      height: "56px",
                      transform: "rotate(150deg)",
                    }),
                  }}
                ></div>
                <div className="absolute -top-8 z-30 bg-[#3C00FF] rounded-full p-2 shadow-[0_0_90px_rgba(255,255,255,0.8)]">
                  <img
                    src={item.icon}
                    alt={item.title}
                    className="w-10 h-10 object-contain"
                  />
                </div>
                <div className="relative z-20 bg-[rgba(255,255,255,0.1)]  rounded-2xl border-2 border-[#ffffff1a] p-6 pt-10 text-center before:absolute before:content-[''] before:top-0 before:left-1/2 before:-translate-x-1/2 before:w-[100%] before:h-[100%] before:-z-10 before:bg-[radial-gradient(ellipse_at_top,_rgba(255,255,255,0.2)_0%,_transparent_100%)]">
                  <h4 className="text-lg font-semibold mb-2">{item.title}</h4>
                  <p className="text-sm text-gray-300">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
          <div className="lg:hidden relative flex flex-col justify-center items-center">
            <div className="w-screen text-center pb-7 break-words p-4 flex flex-col gap-8">
              <h3 className="text-3xl font-bold ">
                Powered by
                <br />
                <span className="bg-[linear-gradient(90deg,_#3C00FF_0%,_#C800FF_51.5%)] bg-clip-text text-transparent">
                  Blockchain
                </span>{" "}
                Technology
              </h3>
              <p className="text-2xl">
                “Transparency, Security, and Efficiency at Every Step"
              </p>
              <p className="text-2xl font-medium ">
                Coaler leverages blockchain technology to revolutionize the coal
                supply chain.
              </p>
            </div>
            <div className="block lg:hidden w-screen px-4">
              {!viewAllBlock ? (
                <Swiper
                  modules={[Autoplay]}
                  slidesPerView="auto"
                  centeredSlides={true}
                  loop={true}
                  autoplay={{ delay: 2500, disableOnInteraction: false }}
                  className="w-full"
                >
                  {benifits.BLOCKCHAINBENEFITS.map((item, i) => (
                    <SwiperSlide
                      key={i}
                      className="flex items-center justify-center !w-[270px]"
                    >
                      <div className="relative w-full min-h-[160px] py-4 px-2.5 flex flex-col items-center justify-start  ">
                        {/* Icon Above Card */}
                        

                        {/* Card */}
                        <div className="bg-white/10  backdrop-blur-md min-h-[220px] rounded-2xl border-[2px] border-[#FFFFFF1A] p-6 pt-10 text-center w-full">
                          <div className="flex gap-3">
                          <img
                            src={item.icon}
                            alt={item.title}
                            className="w-10 h-10 object-contain  bg-[#3C00FF] rounded-full p-2"
                          />

                          <h4 className="text-lg font-semibold mb-2">
                            {item.title}
                          </h4>
                        </div>
                          
                          <p className="text-sm text-gray-300">{item.desc}</p>
                        </div>
                      </div>
                    </SwiperSlide>
                  ))}
                </Swiper>
              ) : (
                <div className="flex flex-col items-center justify-center space-y-6 mt-8">
                  {benifits.BLOCKCHAINBENEFITS.map((item, i) => (
                    <div
                      key={i}
                      className="relative w-full max-w-[270px] min-h-[160px] py-4 px-2.5 flex flex-col items-center justify-start"
                    >
                      {/* Icon Above Card */}
                      <div className="absolute top-0 z-20 bg-[#3C00FF] rounded-full p-2">
                        <img
                          src={item.icon}
                          alt={item.title}
                          className="w-10 h-10 object-contain"
                        />
                      </div>

                      <div className="bg-[#1a1a1a] min-h-[220px] rounded-2xl border-[3px] border-[#1B0073] p-6 pt-10 text-center w-full">
                        <h4 className="text-lg font-semibold mb-2">
                          {item.title}
                        </h4>
                        <p className="text-sm text-gray-300">{item.desc}</p>
                      </div>
                    </div>
                  ))}
                </div>
              )}

              {!viewAllBlock && (
                <div className="flex flex-col items-center justify-center mt-8">
                  <button
                    onClick={() => setViewAllBlock(true)} // renamed here too
                    className="flex items-center gap-2 px-6 py-2  text-white rounded-full text-sm font-semibold hover:bg-[#2a00cc] transition"
                  >
                    View All
                    <img
                      src="/down_symbol.png"
                      alt="Down Arrow"
                      className="w-4 h-4 object-contain"
                    />
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default BlockchainDiagram;
